import {
  Button,
  FormControl,
  Grid,
  TextField,
  Typography,
} from '@mui/material';
import React, {useState} from 'react';
import '../../App.css';
import FirestoreManager from '../../api/firebaseManager';
import {useAuth} from '../../hooks/use-auth';
import {useBill} from '../../hooks/use-bill';
import {Modal} from '../modal/modal';

export const BillModal = ({active, setActive}) => {
  const {
    state: {profile},
  } = useAuth();

  const [index, setIndex] = useState(0);
  const [form, setForm] = useState({
    uid: profile.uid,
    customerID: profile.customerID,
    userName: '',
    password: '',
    entity_name: '',
    company: '',
    accounts_payable: '',
    accounts_receivable: '',
    vendor_credits: '',
    credit_memo: '',
    organizations: [],
    error: null,
  });

  return (
    <Modal active={active} setActive={setActive}>
      <div className="box flex-column">
        {index === 0 && (
          <ConnectBill
            form={form}
            setForm={setForm}
            setIndex={setIndex}
            setActive={setActive}
          />
        )}
        {index === 1 && (
          <DefineAccounts
            form={form}
            setForm={setForm}
            setIndex={setIndex}
            setActive={setActive}
          />
        )}
      </div>
    </Modal>
  );
};

const ConnectBill = ({form, setForm, setIndex, setActive}) => {
  const {
    state: {connection_ids},
  } = useBill();

  const [loading, setLoading] = useState(false);

  return (
    <div>
      <Typography sx={{textAlign: 'center', fontSize: '22px'}}>
        Connecting to Bill.com
      </Typography>
      <Typography>
        Enter the following information to receive transactions from Bill.com.
      </Typography>
      <br />
      <Typography>
        Contact Support@forestsystems.com if you have any questions.
      </Typography>
      <div className="box">
        <Grid container spacing={0}>
          <Grid
            item
            xs={6}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}>
            <Typography>Forest Entity Name:</Typography>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <TextField
                id="entity_name"
                label="Entity Name"
                placeholder="entity_name"
                value={form.entity_name}
                type="text"
                onChange={evt =>
                  setForm({...form, entity_name: evt.target.value})
                }
                variant="filled"
              />
            </FormControl>
          </Grid>
        </Grid>
        <br />
        <Typography>
          To view the name of the Forest database you are trying to connect, log
          on to Forest View and Users | Administrative. The name is displayed
          under Select a database.
        </Typography>
        <br />
        <Grid container spacing={0}>
          <Grid
            item
            xs={6}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}>
            <Typography>Bill Company Name:</Typography>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <TextField
                id="company"
                label="Company"
                placeholder="Company"
                value={form.company}
                type="text"
                onChange={evt => setForm({...form, company: evt.target.value})}
                variant="filled"
              />
            </FormControl>
          </Grid>
        </Grid>
        <br />
        <Typography>
          This is the company name within Bill.com. It is usually displayed on
          the top left of the screen when entering payable and receivable
          transactions.
        </Typography>
        <br />
        <br />
        <Grid container spacing={0}>
          <Grid
            item
            xs={6}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}>
            <Typography>Sync token Name:</Typography>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <TextField
                id="userName"
                label="Username"
                placeholder="UserName"
                value={form.userName}
                type="text"
                onChange={evt => setForm({...form, userName: evt.target.value})}
                variant="filled"
              />
            </FormControl>
          </Grid>
          <br />
          <Grid container spacing={0}>
            <Grid
              item
              xs={6}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}>
              <Typography>Sync Token Password:</Typography>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <TextField
                  id="password"
                  label="Password"
                  placeholder="Password"
                  value={form.password}
                  type="password"
                  onChange={evt =>
                    setForm({...form, password: evt.target.value})
                  }
                  variant="filled"
                />
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
        <br />
        <Typography>
          Tokens can be found and created from within Bill.com. Go to Settings |
          Sync & Integrations | Tokens
        </Typography>
        <br />
        <Typography>
          Token passwords are displayed only once. Delete and recreate tokens to
          generate a new password.
        </Typography>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}>
        <Button
          onClick={() => setActive(false)}
          style={{
            zIndex: 1,
            backgroundColor: '#c5c7c6',
            height: '30px',
            border: '0px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0px 32px',
            margin: '16px 32px 0px 32px',
            color: 'black',
          }}>
          Close
        </Button>
        <Button
          disabled={loading}
          style={{
            zIndex: 1,
            backgroundColor: '#c5c7c6',
            height: '30px',
            border: '0px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0px 32px',
            margin: '16px 32px 0px 32px',
            color: 'black',
          }}
          onClick={async () => {
            const {userName, password, entity_name, company} = form;
            if (!userName || !password || !entity_name || !company) {
              window.alert('Fill out all fields to continue.');
              return;
            }

            const exists = connection_ids.find(id => id === userName);
            if (exists) {
              window.alert('Connection already exists.');
              return;
            }

            setLoading(true);

            const response = await FirestoreManager.getBillOrganizations({
              userName,
              password,
            });

            const {success, error, data} = response;
            if (success) {
              const {response_status, response_message, response_data} = data;
              if (response_status === 0) {
                setForm({...form, organizations: response_data});
                setIndex(1);
              } else {
                const {error_message} = response_data;
                window.alert(
                  error_message ||
                    'Something went wrong. Please try again or reach out to Support@forestsystems.com.',
                );
              }
            }
            if (error) {
              window.alert(
                'Something went wrong. Please try again or reach out to Support@forestsystems.com.',
              );
            }
            setLoading(false);
          }}>
          Next
        </Button>
      </div>
    </div>
  );
};

const DefineAccounts = ({form, setForm, setIndex, setActive}) => {
  const {createConnection} = useBill();

  return (
    <div>
      <Typography sx={{textAlign: 'center', fontSize: '22px'}}>
        Connecting to Bill.com
      </Typography>
      <br />
      <Typography>
        The Forest and Bill.com integration requires 4 journal accounts in
        Forest Enter. The exact names of these accounts are identified here for
        the integration to balance and create double entry transactions with
        Bill.com data.
      </Typography>
      <div className="box">
        <Grid container spacing={0}>
          <Grid
            item
            xs={6}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}>
            <Typography>Accounts Payable:</Typography>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <TextField
                id="accounts_payable"
                label="Accounts Payable"
                placeholder="accounts_payable"
                value={form.accounts_payable}
                type="text"
                onChange={evt =>
                  setForm({...form, accounts_payable: evt.target.value})
                }
                variant="filled"
              />
            </FormControl>
          </Grid>
        </Grid>
        <br />
        <Typography>
          Enter the Forest account name for Accounts Payable. This account is
          used to balance bill, payment out, and vendor credit data from
          Bill.com
        </Typography>
        <br />
        <Grid container spacing={0}>
          <Grid
            item
            xs={6}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}>
            <Typography>Accounts Receivable:</Typography>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <TextField
                id="accounts_receivable"
                label="Accounts Receivable"
                placeholder="accounts_receivable"
                value={form.accounts_receivable}
                type="text"
                onChange={evt =>
                  setForm({...form, accounts_receivable: evt.target.value})
                }
                variant="filled"
              />
            </FormControl>
          </Grid>
        </Grid>
        <br />
        <Typography>
          Enter the Forest account name for Accounts Receivable. This account is
          used to balance invoice, payment in, and credit memo data from
          Bill.com
        </Typography>
        <br />
        <Grid container spacing={0}>
          <Grid
            item
            xs={6}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}>
            <Typography>Vendor Credits:</Typography>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <TextField
                id="vendor_credits"
                label="Vendor Credits"
                placeholder="vendor_credits"
                value={form.vendor_credits}
                type="text"
                onChange={evt =>
                  setForm({...form, vendor_credits: evt.target.value})
                }
                variant="filled"
              />
            </FormControl>
          </Grid>
        </Grid>
        <br />
        <Typography>
          Enter the Forest account name for Vendor Credits.
        </Typography>
        <br />
        <Grid container spacing={0}>
          <Grid
            item
            xs={6}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}>
            <Typography>Credit Memo:</Typography>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <TextField
                id="credit_memo"
                label="Credit Memo"
                placeholder="credit_memo"
                value={form.credit_memo}
                type="text"
                onChange={evt =>
                  setForm({...form, credit_memo: evt.target.value})
                }
                variant="filled"
              />
            </FormControl>
          </Grid>
        </Grid>
        <br />
        <Typography>Enter the Forest account name for Credit Memos.</Typography>
        <br />
      </div>
      <br />
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}>
        <Button
          onClick={() => setIndex(0)} // nav back to the previous modal
          style={{
            zIndex: 1,
            backgroundColor: '#c5c7c6',
            height: '30px',
            border: '0px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0px 32px',
            margin: '16px 32px 0px 32px',
            color: 'black',
          }}>
          Back
        </Button>
        <Button
          style={{
            zIndex: 1,
            backgroundColor: '#c5c7c6',
            height: '30px',
            border: '0px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0px 32px',
            margin: '16px 32px 0px 32px',
            color: 'black',
          }}
          onClick={async () => {
            const {
              accounts_payable,
              accounts_receivable,
              vendor_credits,
              credit_memo,
            } = form;

            if (
              !accounts_payable ||
              !accounts_receivable ||
              !vendor_credits ||
              !credit_memo
            ) {
              window.alert('Fill out all fields to continue.');
              return;
            }

            const {success, error} = await createConnection(form);
            if (success) {
              setIndex(0);
              setActive(false);
              window.alert('Bill.com connection was successful.');
            }

            if (error) {
              window.alert(
                'Something went wrong. Please try again or reach out to Support@forestsystems.com.',
              );
            }
          }}>
          Save
        </Button>
      </div>
    </div>
  );
};
